<template>
  <div class="vm-history-list">
          <div v-if="!loading" class="items" @resize="widthItem()">
      <div class="item">
        <div :style="backgroundColor"></div>
        <div class="item-logo" style="margin-left:30px; z-index:2; background:white; border:4px whitesmoke solid">
          <img v-if="avatar" :src="renewAvatar(avatar)" alt="logo" />
          <svg
            v-else
            class="bi bi-camera"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9 5C7.343 5 5 6.343 5 8a4 4 0 0 1 4-4v1z" />
            <path
              fill-rule="evenodd"
              d="M14.333 3h-2.015A5.97 5.97 0 0 0 9 2a5.972 5.972 0 0 0-3.318 1H1.667C.747 3 0 3.746 0 4.667v6.666C0 12.253.746 13 1.667 13h4.015c.95.632 2.091 1 3.318 1a5.973 5.973 0 0 0 3.318-1h2.015c.92 0 1.667-.746 1.667-1.667V4.667C16 3.747 15.254 3 14.333 3zM1.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM9 13A5 5 0 1 0 9 3a5 5 0 0 0 0 10z"
            />
            <path d="M2 3a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1z" />
          </svg>
        </div>
        <div class="vm-item-info">
         <slot name="info">
          Информация
         </slot>
        </div>
        <div v-if="withRightSide" class="vm-item-action" >
          <slot name="rightSideInfo">
          </slot>
        </div>
      </div>
    </div>
        
      </div>  
</template>

<script>
import { theme } from '@app/theme';

export default {
  data() {
    return {
      itemWidth: 0,
      loadingItems: Array.from(new Array(1)).map((v, i) => i),
      ...theme,
    };
  },
  props: {
    item: Object,
    avatar: String,
    timeout: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    withRightSide: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    backgroundColor() {
      const width = this.itemWidth + 'px';
      return {
        width,
        position: 'absolute',
        height: '5px',
        background: this.primaryColor
      };
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth);
    setTimeout(() => { this.updateWidth(); }, this.timeout);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  },
  methods: {
    updateWidth() {
      document.getElementsByClassName('item').forEach(obj => {
        if (obj.offsetWidth > 0) {
          this.itemWidth = obj.offsetWidth;
        }
      });
    },
    widthItem() {
      const width = this.itemWidth + 'px';
      return { width };
    },
    renewAvatar(avatar) {
      if (avatar[0]!=='h') { 
        const url = avatar ? process.env.VUE_APP_API_URL + '/' + avatar : null;
        return url;
      } else {
        return avatar;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.items {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.item {
  width: 80%;
  display: flex;
  margin-top: 1.5rem;
 /* border: 1px solid #dfdfdf;
  border-radius: 0.25rem; */
  background-color: white;
 /* box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.02); */
  transition: background-color 200ms ease;
  overflow: hidden;
  height:120px; 
  background: linear-gradient(to right, rgb(224, 222, 222), transparent)
}


.item-logo {
  height: 100px;
  overflow: hidden;
  flex: 0 0 100px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.05);
  transform: translate(0px, -15px);
  position: absolute;
  width: 95px;
}
.item-logo img {
  max-width: 100%;
  max-height: 100%;
}
.item-logo svg {
  width: 50px;
  height: 50px;
}

.vm-item-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 160px;
}
.vm-item-info .title {
  font-size: 1.5rem;
  color: #262626;
  margin-bottom: 6px;
  line-height: 1;
}
.vm-item-info .subtitle {
  color: #606368;
  line-height: 1;
}
.vm-item-action {
  margin-left: auto;
  display: flex;
  align-items: flex-end;
  padding: 1rem;
  flex-direction: column;
  justify-content: space-between;
}
.vm-button {
  font-weight: 300;
  background: linear-gradient(to right, #8C30DA, #5C48D4);
  border: 1px solid #dbdbdb;
  border-radius: 25px;
  color: white;
  padding: 0.5rem 3rem;
  transition: all 200ms;
  outline: none;
  text-decoration: none;
}
.vm-button:hover {
  border: 1px solid #6cbdee;
  background-color: #6cbdee;
  color: #000;
  cursor: pointer;
}
.link-close:hover {
  cursor: pointer;
}
</style>